(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ilamo-customer-testimonials"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ilamo-review-write]');
    if (!link) return;
    const details = document.getElementById(link.hash.slice(1));
    if (details instanceof HTMLDetailsElement) details.open = true;
  });
  const openIlmoReviewForm = () => {
    const details = document.getElementById(window.location.hash.slice(1));
    if (details instanceof HTMLDetailsElement && details.classList.contains('ilmo-review-form__details')) details.open = true;
  };
  openIlmoReviewForm();
  window.addEventListener('hashchange', openIlmoReviewForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ilamo-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__ilamoProductCard) return;
    window.__ilamoProductCard = true;

    const WISH_KEY = 'ilamo:wishlist';

    const readWishlist = () => {
      try {
        const value = JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
        return Array.isArray(value) ? value : [];
      } catch (error) {
        return [];
      }
    };

    const writeWishlist = (list) => {
      try {
        localStorage.setItem(WISH_KEY, JSON.stringify(list));
      } catch (error) {
        /* storage unavailable: keep the visual state only */
      }
    };

    const syncHearts = (root = document) => {
      const list = readWishlist();
      root.querySelectorAll('[data-ilpc-wish]').forEach((button) => {
        const active = list.includes(button.dataset.ilpcWish);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };

    let toastTimer;
    const toast = (message) => {
      let node = document.querySelector('.ilpc-toast');
      if (!node) {
        node = document.createElement('div');
        node.className = 'ilpc-toast';
        node.setAttribute('role', 'status');
        node.setAttribute('aria-live', 'polite');
        document.body.appendChild(node);
      }
      node.textContent = message;
      requestAnimationFrame(() => node.classList.add('is-visible'));
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => node.classList.remove('is-visible'), 2600);
    };

    const toggleWish = (button) => {
      const handle = button.dataset.ilpcWish;
      const list = readWishlist();
      const index = list.indexOf(handle);
      if (index > -1) {
        list.splice(index, 1);
      } else {
        list.push(handle);
      }
      writeWishlist(list);
      document.querySelectorAll('[data-ilpc-wish]').forEach((item) => {
        if (item.dataset.ilpcWish !== handle) return;
        item.classList.toggle('is-active', index === -1);
        item.setAttribute('aria-pressed', String(index === -1));
      });
      toast(index === -1 ? 'Zur Wunschliste hinzugefügt' : 'Von der Wunschliste entfernt');
    };

    const quickAdd = async (button) => {
      if (button.classList.contains('is-loading')) return;
      const variantId = button.dataset.ilpcAdd;
      const productId = button.dataset.productId;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map((element) => element.dataset.sectionId)
        .filter(Boolean);

      const payload = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (sectionIds.length) {
        payload.sections = sectionIds.join(',');
        payload.sections_url = window.location.pathname;
      }

      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          toast(data.description || data.message || 'Der Artikel konnte nicht hinzugefügt werden.');
          return;
        }

        const cartEvent = new Event('cart:update', { bubbles: true });
        cartEvent.detail = {
          resource: {},
          sourceId: String(variantId),
          data: {
            source: 'product-form-component',
            itemCount: 1,
            productId: String(productId),
            variantId: String(variantId),
            sections: data.sections,
          },
        };
        button.dispatchEvent(cartEvent);

        button.classList.add('is-added');
        setTimeout(() => button.classList.remove('is-added'), 1800);

        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && !drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') {
          drawer.open();
        } else if (!drawer) {
          toast('Im Warenkorb');
        }
      } catch (error) {
        toast('Der Artikel konnte nicht hinzugefügt werden.');
      } finally {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }
    };

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const wish = target.closest('[data-ilpc-wish]');
      if (wish) {
        event.preventDefault();
        toggleWish(wish);
        return;
      }

      const add = target.closest('button[data-ilpc-add]');
      if (add) {
        event.preventDefault();
        quickAdd(add);
      }
    });

    const start = () => {
      syncHearts();
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node instanceof Element && (node.matches('[data-ilpc]') || node.querySelector('[data-ilpc]'))) {
              syncHearts(node);
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    window.addEventListener('pageshow', () => syncHearts());
    document.addEventListener('shopify:section:load', (event) => syncHearts(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
